module.exports = __webpack_public_path__ + "static/block3-f33fc0f1779bcc9814cd7d0cb7ac4425.jpg";